module.exports = __webpack_public_path__ + "static/media/icon-user-drop.f284ce21.svg";